"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import AccordionItemProvider from "../provider/AccordionItem";
import type { AccordionItemProps } from "../types";

function AccordionItem({ className, children, ...props }: AccordionItemProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <AccordionItemProvider isOpen={isOpen} setIsOpen={setIsOpen}>
      <AccordionPrimitive.Item
        data-slot="accordion-item"
        className={cn("border-b", className, classes)}
        {...native}
      >
        {children}
      </AccordionPrimitive.Item>
    </AccordionItemProvider>
  );
}

AccordionItem.displayName = "Accordion.Item";

export default AccordionItem;
